$(document).ready(function () {
  $(".collapse").on("hide.bs.collapse show.bs.collapse", function () {
    $(this)
      .prev()
      .find(".glyphicon")
      .toggleClass("glyphicon-chevron-down glyphicon-chevron-right");
  });

  $("#expandAll").on("click", function () {
    $(".accordion-content-area").not(".in").collapse("show");
  });

  $("#collapseAll").on("click", function () {
    $(".accordion-content-area.in").collapse("hide");
  });
});
